export const GET_ORDER = 'GET_ORDER';

export default {
  GET_ORDER,
};



// WEBPACK FOOTER //
// ./src/store/modules/order/mutation-types.js